import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import { createLogger } from 'redux-logger';

import reducers from 'store/reducers';
import config from 'config';

const middleware = getDefaultMiddleware();

if(__DEVELOPMENT__) {
    middleware.push(createLogger(config['redux-logger'] || {}));
}

const store = configureStore({
    devTools: true,
    reducer : reducers,
    middleware
});

export default store;
